import type { MenuItemProps } from "@mui/material";
import { useMemo } from "react";

import type { ItemProps } from "@citrine/atoms/item";
import type { ColorName } from "@citrine/theme";
import { alphabetize } from "@citrine/utils/sorting";

export type SelectOptionObject<ValueType extends string | undefined = string> =
  ItemProps<ValueType> & {
    addSeparator?: boolean;
    color?: ColorName;
    group?: string;
    onClick?: MenuItemProps["onClick"];
  };

export type SelectOption<ValueType extends string | undefined = string> =
  | ValueType
  | SelectOptionObject<ValueType>;

export function useOptionObjects<ValueType extends string = string>(
  options: readonly SelectOption<ValueType>[]
): SelectOptionObject<ValueType>[] {
  return useMemo(
    () =>
      options.map((option) =>
        typeof option === "string" ? { value: option } : option
      ),
    [options]
  );
}

export const sortByValue = alphabetize<SelectOptionObject>("value");
